import React from 'react'
import "./style/AuthLoader.css";

const AuthLoader = () => {
  return (
    <div className="auth-loader"></div>
  )
}

export default AuthLoader